/** Accept only an absolute path within this application, including query/hash. */
export function localNavigationPath(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
  // Browsers normalize backslashes into slashes and discard some control bytes.
  // Validate before parsing so "/\\host" cannot become a network-path reference.
  if (/[\\\u0000-\u0020\u007f]/.test(value)) return null;
  try {
    const base = 'https://local-navigation.invalid';
    const url = new URL(value, base);
    if (url.origin !== base || url.pathname.startsWith('//')) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
